import { createContext } from 'react';

export interface BaseWidgetActionsContextType {
  isMenuVisible: boolean;
  setIsMenuVisible: (isVisible: boolean) => unknown;
}

export const BaseWidgetActionsContext = createContext<BaseWidgetActionsContextType>({
  isMenuVisible: false,
  setIsMenuVisible: () => undefined,
});
